import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";

export class ShowExtraSpinPrompt implements SimplePresentation {

    shouldRun(): boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        if (FlightMode.apiPlugin.isReplay) {
            if (FlightMode.model.nextPlayerInteraction?.playExtraSpin != undefined) {
                FlightMode.transitionScreen.extraSpin.replay(controller);
            } else {
                FlightMode.apiPlugin.betHandler.zeroBet();
                controller.finish();
            }
        } else {
            FlightMode.transitionScreen.extraSpin.enable(controller);
        }
    }
}
